<template>
  <div class="table-page">
    <Row class="v-table-page-buttons">
      <Col span="12" class="v-table-page-buttons-left">
        <slot></slot>
        <slot name="buttons"></slot>
      </Col>
    </Row>
    <Table border highlight-row stripe
      :loading="tableLoading"
      :columns="columns"
      :data="pageContent.content"
      @on-sort-change="sortChange"
      @on-row-click="handleRowClick"
      @on-select="handleSelect"
      @on-select-cancel="handleSelectCancel"
      @on-select-all="handleSelectAll"
      @on-select-all-cancel="handleSelectAllCancel"
      @on-selection-change="handleSelectionChange"
      v-bind="$attrs"></Table>
    <div class="search-page">
      <Page
        :total="pageContent.total"
        :current="pageContent.pageNumber"
        :pageSize="pageContent.pageSize"
        show-sizer
        show-elevator
        show-total
        :size="computedPSize"
        :page-size-opts="[10, 20, 30, 50, 100]"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VueTablePage',
  components: {},
  props: {
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    pSize: {
      type: String,
      default: () => null
    },
    pageSize: {
      type: Number,
      default: () => 10
    },
    searchParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    defaultSort: {
      type: Object,
      default: () => {
        return {
          sortKey: '',
          sortOrder: ''
        }
      }
    },
    list: {
      type: Function
    }
  },
  computed: {
    computedPSize () {
      if (this.pSize) {
        return this.pSize
      }
      return this.$attrs.size === 'small' ? 'small' : this.pSize
    }
  },
  data () {
    return {
      // 加载条
      tableLoading: false,
      // 分页
      pageContent: {
        content: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortKey: '',
        sortOrder: '',
        defaultSortKey: '',
        defaultSortOrder: ''
      }
    }
  },
  methods: {
    // 切换页面
    pageChange (pageNumber) {
      this.pageContent.pageNumber = pageNumber
      this.handleSearch(false, this.pageContent)
    },
    // 切换pagesize
    pageSizeChange (pageSize) {
      this.pageContent.pageSize = pageSize
      this.handleSearch(true)
    },
    // 排序
    sortChange (sortParams) {
      if (sortParams) {
        this.pageContent.sortKey = sortParams.key
        this.pageContent.sortOrder = sortParams.order
      }

      this.handleSearch(false)
    },
    // 查询
    handleSearch (resetPage) {
      this.tableLoading = true
      // 获取查询参数
      let params = {
        searchParams: this.searchParams,
        pageContent: this.pageContent
      }

      // 是否重置页面
      if (resetPage) {
        params.pageContent.pageNumber = 1
      }

      this.list(params).then(res => {
        this.pageContent = res.data
        this.tableLoading = false
      })
    },
    // 单机一行
    handleSelect (selection, item) {
      this.$emit('on-select', selection, item)
    },
    handleSelectCancel (selection, item) {
      this.$emit('on-select-cancel', selection, item)
    },
    handleSelectAll (selection) {
      this.$emit('on-select-all', selection)
    },
    handleSelectAllCancel (selection) {
      this.$emit('on-select-all-cancel', selection)
    },
    handleSelectionChange (selection) {
      this.$emit('on-selection-change', selection)
    },
    handleRowClick (item) {
      this.$emit('on-row-click', item)
    }
  },
  mounted () {
    this.pageContent.sortKey = this.defaultSort.sortKey
    this.pageContent.sortOrder = this.defaultSort.sortOrder
    this.pageContent.defaultSortKey = this.defaultSort.defaultSortKey
    this.pageContent.defaultSortOrder = this.defaultSort.defaultSortOrder
  }
}
</script>

<style lang="less" scoped="scoped">
  .table-page {
    .v-table-page-buttons {
      margin-bottom: 5px;
      .v-table-page-buttons-left {
        text-align: left;
      }
      .v-table-page-buttons-right {
        padding-right: 10px;
        text-align: right;
      }
    }
    .search-page {
      padding-top: 5px;
      padding-right: 10px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tables/vue-table-page.vue